import React from 'react';
import { NavLink  } from "react-router-dom";

import './AdvencedSection.scss';

const AdvencedSection = (props) => {
  const {items, theme, title} = props;
  const colValue = 12 / items.length;
  return (
    <section className={`section-advenced-link theme-${theme}`} id={props.id || null}>
      <div className="container">
        <div className="row">
          <div className="col-12">
            <h2>{title}</h2>
          </div>
          {
            items.map((item, index) => (
              <div key={index} className={`col-12 col-md-${colValue}`}>
                <h4>{item.title}</h4>
                <img src={item.image} alt="" />
                {
                  item.link ?
                  <NavLink exact to={item.link} activeClassName="active">
                    <button className="base-button">więcej</button>
                  </NavLink > :
                  <button className="base-button">więcej</button>
                }
                
              </div>
            ))
          }
        </div>
      </div>
    </section>
  );
}

export default AdvencedSection;